import * as types from '@/store/mutationTypes';

export const mutations = {
    [types.SET_PROFILE_INFO](state, profileInfo) {
        state.profileInfo = profileInfo;
    },

    [types.UPDATE_PROFILE](state, editInfo) {
        state.editProfileInfo = editInfo;
    },

    [types.SET_PROFILE_AVATAR](state, profileAvatar) {
        state.profileAvatar = profileAvatar;
    },

    [types.SET_PROFILE_NOTIFICATIONS_STATUS](state, notificationsStatus) {
        state.notificationsStatus = notificationsStatus;
    },

    [types.SET_HEADING_AVATAR_LOADING](state, hasHeadingAvatarLoaded) {
        state.hasHeadingAvatarLoaded = hasHeadingAvatarLoaded;
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/profile/mutations.js